import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { GroupStorage } from "../../../models/auto-generated";
import { GroupStorageGuard } from "../../guards/group-storage.guard";
import { SharePointExistsGuard } from "../../guards/sharepoint-exists.guard";
import { AddEditSharePointComponent } from "./add-edit-sharepoint/add-edit-sharepoint.component";
import { ExplicitFolderPermissionsComponent } from "./explicit-folder-permissions/explicit-folder-permissions.component";
import { PermissionMappingComponent } from "./permission-mapping/permission-mapping.component";
import { UserMappingComponent } from "./user-mapping/user-mapping.component";
import { GroupsComponent} from "./groups/groups.component";
import { AutomaticSharepointUserCreationGuard} from "../../guards/automatic-sharepoint-user-creation.guard";

const routes: Routes = [
  {
    path: "",
    redirectTo: "create",
    pathMatch: "full"
  },
  {
    path: "create",
    component: AddEditSharePointComponent,
    canActivate: [GroupStorageGuard],
    data: { groupStorage: GroupStorage.SharePoint }
  },
  {
    path: ":sharepoint-id",
    canActivate: [SharePointExistsGuard],
    children: [
      {
        path: "",
        component: AddEditSharePointComponent
      },
      {
        path: "permission-mapping",
        component: PermissionMappingComponent
      },
      {
        path: "user-mapping",
        component: UserMappingComponent
      },
      {
        path: "explicit-folder-permissions",
        component: ExplicitFolderPermissionsComponent
      },
      {
        path: "groups",
        component: GroupsComponent,
        canActivate: [AutomaticSharepointUserCreationGuard]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SharePointRoutingModule {}
